// extracted by mini-css-extract-plugin
export default {"container":"NavBarOrderTimeSwitch_container__UjRoD","navBar":"NavBarOrderTimeSwitch_navBar__4RY9t","capitalize":"NavBarOrderTimeSwitch_capitalize__UQ1J7"};